import { Controller } from "@hotwired/stimulus"

// The recipe page's "Get the ingredients" sheet. Just show/hide + scroll-lock +
// escape + backdrop — the cards inside own their actions, so this adds no
// shopping logic of its own.
export default class extends Controller {
  static targets = ["sheet"]

  open() {
    this.sheetTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this.escHandler = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this.escHandler)
  }

  close() {
    this.sheetTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    if (this.escHandler) {
      document.removeEventListener("keydown", this.escHandler)
      this.escHandler = null
    }
  }

  backdrop(event) {
    if (event.target === event.currentTarget) this.close()
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
    if (this.escHandler) document.removeEventListener("keydown", this.escHandler)
  }
}
